import * as React from 'react';
import { SVGProps } from 'react';

const IconProcessingSizeXs = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.937.75h1.125l.333.886c.428.133.815.36 1.137.657l.934-.155.563.974-.601.73a3.01 3.01 0 0 1 0 1.315l.6.73-.562.975-.934-.155c-.322.297-.709.524-1.137.657l-.333.886H3.937l-.332-.886a2.997 2.997 0 0 1-1.137-.657l-.934.155-.563-.974.601-.73a3.01 3.01 0 0 1 0-1.315l-.6-.73.562-.975.934.155c.322-.297.709-.524 1.137-.657L3.937.75ZM4.5 6a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Zm4.875 0h-.75l-.283.848c-.33.1-.63.276-.877.506l-.876-.179-.375.65.593.668a2.257 2.257 0 0 0 0 1.014l-.593.668.375.65.876-.18c.247.23.546.406.877.507l.283.848h.75l.283-.848c.33-.1.63-.276.877-.506l.876.179.375-.65-.593-.668a2.255 2.255 0 0 0 0-1.014l.593-.668-.375-.65-.876.18a2.248 2.248 0 0 0-.877-.507L9.375 6ZM9 10a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z"
    />
  </svg>
);
export default IconProcessingSizeXs;
